
const pagesTitleCat: Array<string> = [
    'Datos personales',
    'Datos de tu hogar',
    'Seleccioná tu plan',
    'Detalles de tu oferta'
];

const pagesSubTitleCat: Array<string> = [
    '¡Queremos conocerte! Ingresá los siguientes datos, según tu documento de identidad',
    'Ingresá los siguientes datos de tu hogar que deseas asegurar',
    'A continuación selecciona el plan de tu preferencia e ingresá el valor de tu hogar y tus bienes',
    'Te presentamos las coberturas y prima de tu oferta de Seguro Incendio Hogar'
];

const typeDocument = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
];

const txtAcceptTerm: string = "En cumplimiento con la Ley 8204 y la Política Conozca a su Cliente, declaro que este formulario ha sido completado por mí y/o en mi presencia y que la información provista en el mismo es fiel y verdadera. Asi mismo, declaro que los recursos por movilizar a través de Seguro LAFISE (en adelante S.L.) provienen de actividades lícitas. La información de este formulario puede ser utilizada por cualquiera de las empresas del S.L. para los fines respectivos.";


const hostname = window.location.hostname;
const isProductionCR = hostname.includes('appscr.seguroslafise.com');//PRO, ERROR ENTRE PRE Y PRO, CAMBIAN LOS PAQUETES
const plan = isProductionCR == false ? {
    colon: 544, //   Micrositio IH Colones
    dolar: 543 //Micrositio IH Dólares
} : {
    colon: 544, //   Micrositio IH Colones
    dolar: 543 //Micrositio IH Dólares
}

const currency = [
    { value: 'U$', text: 'Dólares' },
    { value: '¢', text: 'Colones' }
]

export { pagesTitleCat, pagesSubTitleCat, typeDocument, txtAcceptTerm, plan, currency };